export const post = (url = '', obj = {}, success = (_d: any) => { }, error = (_d: any) => { }) => {
    let xhr = new XMLHttpRequest();
    xhr.responseType = 'json';
    xhr.open("POST", url);
    xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
            return;
        }
        if (xhr.status === 200) {
            success(xhr.response);
            return;
        }
        if (xhr.status > 299) {
            error(xhr);
            return;
        };
    }
    xhr.send(FormDataFotmat(obj));
}
const FormDataFotmat = (o: any) => {
    const formData = new FormData();
    Object.keys(o).forEach(key => {
        switch (typeof o[key]) {
            case 'object':
                formData.append(key, JSON.stringify(o[key]));
                break;
            default:
                formData.append(key, o[key]);
        }
    });
    return formData;
};